import { z } from "zod";

import { type TimestampShared } from "../utils/sharedDataTypes";

const requiredError = "Bitte gib ein Statement zu diesem Punkt ab.";
const notNumberError = "Bitte gib eine Zahl ein.";

export const FeedbackPostBodySchema = z.object({
  easyToUse: z
    .number({
      error: (issue) => (issue.input === undefined ? requiredError : notNumberError),
    })
    .min(0)
    .max(5),
  contentFit: z
    .number({
      error: (issue) => (issue.input === undefined ? requiredError : notNumberError),
    })
    .min(0)
    .max(5),
  happyWithTheChoices: z
    .number({
      error: (issue) => (issue.input === undefined ? requiredError : notNumberError),
    })
    .min(0)
    .max(5),
  recentUses: z
    .number({
      error: (issue) => (issue.input === undefined ? requiredError : notNumberError),
    })
    .min(0)
    .max(5),
  recommended: z.boolean(),
  writtenFeedback: z.string().optional(),
});

// Use z.infer to create a type that matches the Zod schema
export type FeedbackPostType = z.infer<typeof FeedbackPostBodySchema>;

/** Document shape in `feedback` after {@link sendFeedback} persists server fields. */
export interface FeedbackStoredDocument extends FeedbackPostType {
  userId: string;
  timestamp: TimestampShared;
}
